import { buildCmmdReauthHref } from "../ChatView.logic";

/**
 * Resolves the href for the primary settings/sign-in CTA on a GitHub
 * action-required blocker. Shared by the transcript row and the composer
 * action-required panel so both link to the same recovery surface.
 *
 * Kept in the chat layer (not session-logic) because `connect_cmmd` reauth
 * resolves the primary Forge/CMMD login origin via `buildCmmdReauthHref`, a
 * browser-context helper. That call can throw on desktop/edge with no
 * resolvable primary target — we fall back to `null` (same as the default
 * arm) so the blocker still renders without a settings button.
 */
export function actionRequiredSettingsHref(action: string): string | null {
  switch (action) {
    case "connect_github":
      return "/settings/git";
    case "connect_cmmd":
      try {
        return buildCmmdReauthHref();
      } catch {
        return null;
      }
    default:
      return null;
  }
}
